import { rankingData } from '@/mocks/home-data';

const tagColors: Record<string, string> = {
  '爆': 'bg-primary-500 text-white',
  '热': 'bg-accent-500 text-white',
  '新': 'bg-secondary-500 text-white',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-8 h-8 flex items-center justify-center bg-primary-100 rounded-lg">
            <i className="ri-fire-line text-primary-600 text-base"></i>
          </span>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">热度榜单</h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8 ml-11">实时更新 · 每15分钟刷新</p>

        <div className="grid grid-cols-1 gap-3">
          {rankingData.map((item, index) => (
            <div
              key={item.id}
              className="flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-md font-bold text-sm flex-shrink-0 ${
                index < 3 ? 'bg-primary-500 text-white' : 'bg-secondary-100 text-secondary-700'
              }`}>
                {index + 1}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full whitespace-nowrap ${tagColors[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.hot}</span>
                <span className="text-xs text-foreground-400 hidden sm:block whitespace-nowrap">{item.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}